(function () {
  if (window.__lylahCmp) return;
  window.__lylahCmp = true;

  var d = document;
  var root = d.documentElement;
  root.classList.add('ly-js');
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var hasIO = 'IntersectionObserver' in window;
  var ioFired = false;

  function q(sel, scope) { return Array.prototype.slice.call((scope || d).querySelectorAll(sel)); }
  function sectionOf(el) { return el.closest('.lylah-cmp'); }

  /* Sticky / floating theme header */
  function pinned(el) {
    for (var n = el; n && n !== d.body && n !== root; n = n.parentElement) {
      var p = getComputedStyle(n).position;
      if (p === 'fixed' || p === 'sticky') return p;
    }
    return '';
  }
  function headerOffsets() {
    var sels = 'header, sticky-header, .header, .site-header, .header-wrapper, .shopify-section-header, .shopify-section-group-header-group, #shopify-section-header, [id*="header" i].shopify-section';
    var sticky = 0, maxBottom = 0, sy = window.pageYOffset || 0;
    q(sels).forEach(function (el) {
      if (el.closest('.lylah-cmp')) return;
      var r = el.getBoundingClientRect();
      if (r.height < 20 || r.height > 400 || r.width < 200) return;
      var pin = pinned(el);
      var absBottom = pin === 'fixed' ? r.bottom : r.bottom + sy;
      if (pin) sticky = Math.max(sticky, r.bottom > 0 ? r.bottom : r.height);
      maxBottom = Math.max(maxBottom, absBottom);
    });
    var hero = d.querySelector('.lylah-cmp.ly-hero');
    var overlay = 0;
    if (hero) {
      var cur = parseFloat(getComputedStyle(root).getPropertyValue('--ly-overlay')) || 0;
      var heroTop = hero.getBoundingClientRect().top + sy;
      overlay = Math.max(0, Math.round(maxBottom - heroTop));
      if (cur && overlay === 0) overlay = cur;
    }
    root.style.setProperty('--ly-sticky', Math.round(sticky) + 'px');
    
    return sticky;
  }

  /* Reveal on scroll */
  var VARIANTS = ['ly-r', 'ly-r--left', 'ly-r--scale', 'ly-r--fade', 'ly-r--img', 'ly-in'];
  function finish(el, delay) {
    if (el.__lyDone) return;
    el.__lyDone = true;
    el.classList.add('ly-in');
    setTimeout(function () {
      VARIANTS.forEach(function (c) { el.classList.remove(c); });
      el.style.transitionDelay = '';
    }, (delay || 0) + 1300);
  }
  function play(list) {
    list.sort(function (a, b) {
      var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
      return (ra.top - rb.top) || (ra.left - rb.left);
    });
    list.forEach(function (el, i) {
      var delay = Math.min(i, 10) * 70;
      el.style.transitionDelay = delay + 'ms';
      requestAnimationFrame(function () { finish(el, delay); });
    });
  }
  var pending = [], raf = 0;
  var io = hasIO ? new IntersectionObserver(function (entries) {
    ioFired = true;
    entries.forEach(function (e) {
      if (e.isIntersecting) { io.unobserve(e.target); pending.push(e.target); }
    });
    if (!raf && pending.length) raf = requestAnimationFrame(function () { raf = 0; play(pending.splice(0)); });
  }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }) : null;

  /* Count-up numbers */
  function countUp(el) {
    var raw = (el.getAttribute('data-ly-count') || '').trim();
    var num = parseFloat(raw.replace(/,/g, ''));
    if (isNaN(num) || reduce) return;
    var dec = (raw.split('.')[1] || '').length;
    var comma = raw.indexOf(',') > -1;
    var fmt = function (v) {
      return comma ? v.toLocaleString('en-US', { minimumFractionDigits: dec, maximumFractionDigits: dec }) : v.toFixed(dec);
    };
    var t0 = performance.now(), dur = 1400;
    el.textContent = fmt(0);
    function tick(now) {
      var p = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = p < 1 ? fmt(num * e) : raw;
      if (p < 1) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  var cio = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { cio.unobserve(e.target); countUp(e.target); } });
  }, { threshold: 0.4 }) : null;

  /* Gut-to-heart path fills in once */
  function fillPath(path) {
    q('.ly-step', path).forEach(function (s, i) {
      if (i === 0 || reduce) { s.classList.add('ly-on'); return; }
      setTimeout(function () { s.classList.add('ly-on'); }, i * 550);
    });
  }
  var pio = hasIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { pio.unobserve(e.target); fillPath(e.target); } });
  }, { threshold: 0.5 }) : null;

  /* Comparison table */
  function applyTable(tbl) {
    var comps = (tbl.getAttribute('data-comps') || '').split(',').filter(Boolean);
    var off = (tbl.getAttribute('data-off') || '').split(',').filter(Boolean);
    var vis = comps.filter(function (n) { return off.indexOf(n) < 0; });
    var diff = tbl.getAttribute('data-diff') === '1';
    var secEl = sectionOf(tbl);
    if (secEl) secEl.classList.toggle('is-diff', diff);
    var mcol = tbl.getAttribute('data-mcol') || comps[0];
    var desk = tbl.querySelector('.ly-tbl__desk-wrap');
    if (desk) {
      q('[data-col]', desk).forEach(function (c) { c.classList.toggle('ly-off', off.indexOf(c.getAttribute('data-col')) > -1); });
      desk.style.maxWidth = (430 + vis.length * 210) + 'px';
      var table = desk.querySelector('table');
      if (table) table.style.minWidth = (350 + vis.length * 140) + 'px';
    }
    var alt = 0;
    q('tr[data-ly-row]', tbl).forEach(function (tr) {
      var lyCell = tr.querySelector('.ly-tbl__ly');
      var lv = lyCell ? lyCell.getAttribute('data-v') : '';
      var differs = false;
      vis.forEach(function (n) {
        var c = tr.querySelector('[data-col="' + n + '"]');
        if (!c) return;
        var dv = c.getAttribute('data-v') !== lv;
        if (dv) differs = true;
        c.classList.toggle('ly-same', diff && !dv);
        c.classList.toggle('ly-differs', diff && dv);
      });
      var gone = diff && !differs;
      tr.classList.toggle('ly-gone', gone);
      tr.classList.toggle('ly-alt', !gone && (alt++ % 2 === 1));
    });
    alt = 0;
    q('.ly-mrow', tbl).forEach(function (r) {
      var c = r.querySelector('[data-col="' + mcol + '"]');
      var same = !!c && c.getAttribute('data-v') === r.getAttribute('data-v');
      q('[data-col]', r).forEach(function (x) {
        var sx = x.getAttribute('data-v') === r.getAttribute('data-v');
        x.classList.toggle('ly-same', diff && sx);
        x.classList.toggle('ly-differs', diff && !sx);
      });
      var gone = diff && same;
      r.classList.toggle('ly-gone', !!gone);
      r.classList.toggle('ly-alt', !gone && (alt++ % 2 === 1));
    });
  }
  function tblIn(el) { var s = sectionOf(el); return s && s.querySelector('[data-ly-table]'); }

  /* Head to head */
  function setTab(btn) {
    var sec = sectionOf(btn), n = btn.getAttribute('data-ly-tab');
    q('[data-ly-tab]', sec).forEach(function (b) { b.classList.toggle('is-on', b === btn); b.setAttribute('aria-selected', b === btn ? 'true' : 'false'); });
    q('[data-ly-panel]', sec).forEach(function (p) {
      var on = p.getAttribute('data-ly-panel') === n;
      p.classList.toggle('is-on', on);
      if (on) setSide(p, false);
    });
  }
  function setSide(panel, flipped) {
    panel.classList.toggle('is-flipped', flipped);
    q('[data-ly-side]', panel).forEach(function (b) {
      b.classList.toggle('is-on', (b.getAttribute('data-ly-side') === 'b') === flipped);
    });
  }

  function setOne(el, sel) {
    q(sel, el.parentNode).forEach(function (s) { s.classList.toggle('is-on', s === el); });
  }
  function setStrain(btn) {
    setOne(btn, 'button');
    var box = btn.closest('.ly-cfu');
    var n = box.querySelector('.ly-cfu__name'), a = box.querySelector('.ly-cfu__amt');
    if (n) n.textContent = btn.getAttribute('data-name') || '';
    if (a) a.textContent = btn.getAttribute('data-amt') || '';
  }

  /* Delegated interactions (bound once) */
  d.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('.lylah-cmp a[href^="#"]'))) {
      var id = b.getAttribute('href').slice(1);
      var target = id && d.getElementById(id);
      if (target) {
        e.preventDefault();
        var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffsets() - 12;
        window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
      }
      return;
    }
    if ((b = t.closest('.lylah-cmp .ly-bio'))) return setOne(b, '.ly-bio');
    if ((b = t.closest('.lylah-cmp .ly-step'))) {
      var steps = q('.ly-step', b.parentNode), idx = steps.indexOf(b);
      steps.forEach(function (s, i) { s.classList.toggle('ly-on', i <= idx); });
      return;
    }
    if ((b = t.closest('.lylah-cmp .ly-bar button'))) return setStrain(b);
    if ((b = t.closest('.lylah-cmp [data-ly-col]'))) {
      var tbl = tblIn(b), col = b.getAttribute('data-ly-col');
      var comps = (tbl.getAttribute('data-comps') || '').split(',').filter(Boolean);
      var off = (tbl.getAttribute('data-off') || '').split(',').filter(Boolean);
      var i = off.indexOf(col);
      if (i > -1) off.splice(i, 1);
      else if (off.length < comps.length - 1) off.push(col);
      tbl.setAttribute('data-off', off.join(','));
      q('[data-ly-col]', sectionOf(b)).forEach(function (c) { c.classList.toggle('is-off', off.indexOf(c.getAttribute('data-ly-col')) > -1); });
      return applyTable(tbl);
    }
    if ((b = t.closest('.lylah-cmp [data-ly-mcol]'))) {
      var tb = tblIn(b);
      tb.setAttribute('data-mcol', b.getAttribute('data-ly-mcol'));
      setOne(b, '[data-ly-mcol]');
      return applyTable(tb);
    }
    if ((b = t.closest('.lylah-cmp [data-ly-diff]'))) {
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      var tbd = tblIn(b);
      tbd.setAttribute('data-diff', on ? '1' : '0');
      return applyTable(tbd);
    }
    if ((b = t.closest('.lylah-cmp [data-ly-tab]'))) return setTab(b);
    if ((b = t.closest('.lylah-cmp [data-ly-side]'))) return setSide(b.closest('.ly-h2h'), b.getAttribute('data-ly-side') === 'b');
    if ((b = t.closest('.lylah-cmp .ly-flip'))) {
      var p = b.closest('.ly-h2h');
      return setSide(p, !p.classList.contains('is-flipped'));
    }
  });
  d.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b;
    if ((b = t.closest('.lylah-cmp .ly-bio')) && !b.classList.contains('is-on')) setOne(b, '.ly-bio');
    else if ((b = t.closest('.lylah-cmp .ly-bar button')) && !b.classList.contains('is-on')) setStrain(b);
  });

  /* Init (page load + theme editor reloads) */
  function init(scope) {
    scope = scope || d;
    headerOffsets();
    q('.lylah-cmp .ly-r', scope).forEach(function (el) {
      if (el.__lyDone) return;
      if (reduce || !io) finish(el, 0); else io.observe(el);
    });
    q('.lylah-cmp [data-ly-count]', scope).forEach(function (el) { if (cio) cio.observe(el); });
    q('.lylah-cmp .ly-path', scope).forEach(function (el) { if (pio) pio.observe(el); else fillPath(el); });
    q('.lylah-cmp [data-ly-table]', scope).forEach(applyTable);
  }

  /* Safety net: after 3s reveal anything not yet shown that is on or above screen, or everything if observers never ran */
  setTimeout(function () {
    q('.lylah-cmp .ly-r').forEach(function (el) {
      if (!ioFired || el.getBoundingClientRect().top < window.innerHeight) finish(el, 0);
    });
  }, 3000);

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', function () { init(d); });
  else init(d);
  window.addEventListener('resize', headerOffsets);
  window.addEventListener('load', headerOffsets);

  d.addEventListener('shopify:section:load', function (e) { init(e.target); });
  d.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (el && el.matches && el.matches('.ly-h2h')) {
      var sec = sectionOf(el);
      var tab = sec && sec.querySelector('[data-ly-tab="' + el.getAttribute('data-ly-panel') + '"]');
      if (tab) setTab(tab);
    }
  });
})();
